import { WorkspaceSmsRegistrationBusinessInformationRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms/registration/business-info',
)({
  component: WorkspaceSmsRegistrationBusinessInformationRoute,
});
